import styled from 'styled-components';
import { Row } from 'antd';

export const SettingRow = styled(Row)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  padding: 32px 24px;
  margin-top: 20px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;

  & .setting-description {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 4px;
  }
`;

export const SettingHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & .setting-title {
    font-size: 15px;
    font-weight: 600;
    color: #262626;
  }
`;
